/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FunnelTableItemDto } from './FunnelTableItemDto';
import {
    FunnelTableItemDtoFromJSON,
    FunnelTableItemDtoFromJSONTyped,
    FunnelTableItemDtoToJSON,
    FunnelTableItemDtoToJSONTyped,
} from './FunnelTableItemDto';

/**
 * 
 * @export
 * @interface GetFunnelListResponse
 */
export interface GetFunnelListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetFunnelListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<FunnelTableItemDto>}
     * @memberof GetFunnelListResponse
     */
    items: Array<FunnelTableItemDto>;
}

/**
 * Check if a given object implements the GetFunnelListResponse interface.
 */
export function instanceOfGetFunnelListResponse(value: object): value is GetFunnelListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetFunnelListResponseFromJSON(json: any): GetFunnelListResponse {
    return GetFunnelListResponseFromJSONTyped(json, false);
}

export function GetFunnelListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFunnelListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(FunnelTableItemDtoFromJSON)),
    };
}

export function GetFunnelListResponseToJSON(json: any): GetFunnelListResponse {
    return GetFunnelListResponseToJSONTyped(json, false);
}

export function GetFunnelListResponseToJSONTyped(value?: GetFunnelListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(FunnelTableItemDtoToJSON)),
    };
}

